import React, { ReactNode } from 'react';
import { Card } from 'antd';
import cx from 'classnames';

import styles from './BasePageCard.module.less';

type Props = {
  title: string | ReactNode;
  subTitle?: string | ReactNode;
  icons: ReactNode;
  children: ReactNode;
  className?: string;
  ref?: React.RefObject<HTMLDivElement>;
};

export default React.forwardRef(
  (props: Props, ref: React.Ref<HTMLDivElement>) => {
    const { icons, title, subTitle, children, className } = props;

    return (
      <div ref={ref} className={cx(className, styles.cardWrapper)}>
        <Card>
          <div className={cx('cared-header', styles.cardHeader)}>
            {icons && <span className={styles.icon}>{icons}</span>}

            <div className={cx('header-content', styles.headerContent)}>
              <span className={styles.title}>{title}</span>
              {subTitle && <span className={styles.subTitle}>{subTitle}</span>}
            </div>
          </div>

          <div className={styles.cardContent}>{children}</div>
        </Card>
      </div>
    );
  },
);
